import type { FaireProductEntity } from "../../entity_types/product";

export const p_p5n386s: FaireProductEntity = {
  token: "p_p5n386s",
  type: "product",
  name: "Todos Santos Candle",
  brandName: "Nopalera",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/3bf74004e22b30bd37b91c8ae091fef90a2df6799a6faaea67ae92125f975a94.webp",
  priceDollars: 32,
  description: "Todos Santos candle - Nopalera bestseller",
  categoryTokens: ["cat_bath-all"],
  tags: ["premium", "candle", "bestseller"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/81e61382f9157e0e28a8c44c69ac1859d7a16c4524e699b09c8a4d39c773bdf5.webp",
  weight: 0.35,
  dimensions: {
    width: 2,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
